import API from "../API";

export const AddToCartApi = async (payload) => {
  try {
    const response = await API.post(`/cart`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateCartItemApi = async (payload) => {
  try {
    const response = await API.put(
      `/cart/${payload?.cartItemId || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const RemoveCartItemApi = async (payload) => {
  try {
    const response = await API.delete(`/cart/${payload?.cartItemId || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ClearCartApi = async () => {
  try {
    const response = await API.delete(`/clear/cart`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllCartItemApi = async (payload) => {
  try {
    const response = await API.get(`/cart`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetDeliveryChargeApi = async (payload) => {
  try {
    const response = await API.get(`/delivery/charge?cod=${payload?.cod || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const magicFileUrlApi = async (payload) => {
  try {
    const response = await API.get(
      `/v1/presigned-url?fileName=${payload?.fileName || ""}&contentType=${payload?.contentType || ""}&fileType=${payload?.fileType || ""}&userId=${payload?.userId || ""}&isAndroid=${false}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const fileUploadCompleteApi = async (payload) => {
  try {
    const response = await API.post(`/api/files/complete`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
